import React, { useState, useEffect } from 'react';
import SectionContainer from '../../components/UI/SectionContainer';
import { Row, Col, Alert } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import PasswordPolicySettings from '../../components/security/PasswordPolicySettings';

/**
 * 비밀번호 정책 관리 페이지
 * 역할별(관리자/일반 사용자) 비밀번호 유효기간 설정
 * 의료기기 사이버보안 체크리스트 IA-04, IA-05 준수
 */
const PasswordPolicyPage = () => {
  const [authorized, setAuthorized] = useState(false);
  const { role, isLoading: roleLoading } = useAuth();

  // AuthContext의 역할 정보를 기반으로 권한 확인
  useEffect(() => {
    if (roleLoading) {
      return; // 역할 정보 로딩 중이면 대기
    }
    
    // super_admin 또는 admin 권한 모두 허용
    const hasPermission = role === 'super_admin' || role === 'admin';
    setAuthorized(hasPermission);
  }, [role, roleLoading]);

  // 권한이 없을 경우
  if (!authorized && !roleLoading) {
    return (
      <SectionContainer title="비밀번호 정책 관리">
        <Alert variant="danger">
          <Alert.Heading>접근 권한이 없습니다</Alert.Heading>
          <p>이 페이지는 관리자 이상의 권한이 필요합니다.</p>
        </Alert>
      </SectionContainer>
    );
  }

  // 권한 로딩 중인 경우
  if (roleLoading) {
    return (
      <SectionContainer title="비밀번호 정책 관리">
        <div className="d-flex justify-content-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">로딩중...</span>
          </div>
        </div>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer title="비밀번호 정책 관리">
      <Row className="mb-4">
        <Col>
          <PasswordPolicySettings />
        </Col>
      </Row>
    </SectionContainer>
  );
};

export default PasswordPolicyPage;
